<app-builder-io-renderer *ngIf="apiKey && entry; else loadingTemplate" [apiKey]="apiKey" [entry]="entry">
    <ng-content></ng-content>
</app-builder-io-renderer>

<ng-template #loadingTemplate>
    <mat-spinner [diameter]="32"></mat-spinner>
</ng-template>
